<div fxFlex fxLayout="column" [ngClass]="cssService.sectionCardClass" class="scrolled"
     *ngIf="currSm" [class.more]="panierheight1080">

  <!-- Header -->
  <div class="mb-4">
    <h2 class="text-lg font-semibold text-gray-800">{{"basket.order"|translate}}</h2>
  </div>

  <!-- Mode de vente -->
  <div class="flex flex-row justify-between gap-4 py-2">

    <div class="text-base">{{ currSm.name | uppercase }}</div>

    <button class="text-sm text-indigo-600 hover:underline hover:text-indigo-800 transition"
            *ngIf="(!currSm.disable_authentification  ||currSm.disable_authentification!==1 ) && webshop_visible"
            [class.isDisabled]="currSm.onlyOneSM && !currSm.bookingActive" (click)="openDialSm()" angulartics2On="click"
            angularticsAction="openSaleMethodsDialog"
            angularticsCategory="headers">{{"button.modify"|translate}}</button>

  </div>

  <hr class="border-gray-300"/>

  <!-- Date / Heure commande -->
  <div class="flex flex-row justify-between gap-4 py-2" *ngIf="currSm.enable_date_hour">

    <div>
      <div class="text-base">{{ orderDateHour.day | dateFilter: "dddd D MMM" }}</div>
      <div class="text-sm">{{ orderDateHour.hour | dateFilter: "HH:mm" }}</div>
    </div>

    <button class="text-sm text-indigo-600 hover:underline hover:text-indigo-800 transition"
            (click)="openSelectProductsTimeSlotDial()"
            angulartics2On="click" angularticsAction="openProductsSlotSelectorDial"
            angularticsCategory="headers">{{'button.modify'|translate}}</button>

  </div>

  <hr class="border-gray-300"/>

  <div class="flex-1 scrolled">

    <!-- Panier Vide -->
    <div class="flex flex-col items-center justify-center" *ngIf="isEmptyBasket()">

      <!-- Panier Vide -->
      <div class="flex flex-col gap-2 p-4 items-center" *ngIf="isEmptyBasket()">
        <div class="h-12">
          <img src="assets/img/icons/empty-basket.png" class="h-full object-contain"/>
        </div>
        <div class="text-base text-gray-500">{{ "basket.empty" | translate }}</div>
      </div>

    </div>

    <!-- Panier -->
    <div class=" flex flex-col" *ngIf="!isEmptyBasket()">

      <div *ngFor="let prod of panier$; let index = index; let last = last" class="flex flex-row py-2 gap-2 mr-2">

        <!-- Image -->
        <div>
          <img [src]="prod.image.length > 0 ? prod.image[2] : default_prod" alt="Produit"
               class="w-14 h-14 rounded-lg object-cover">
        </div>

        <div class="flex-1">

          <!-- Infos article -->
          <div class="flex-1 flex flex-col">

            <div class="flex flex-row justify-between">

              <div>
                <h3 class="text-sm font-medium text-gray-800">{{ prod.display_lang.name | capitalize }}</h3>
              </div>

              <div class="text-sm text-gray-800 font-semibold">

                <!-- Total article -->
                <span *ngIf="getSubTotalItemLine(prod) != 0">{{ getSubTotalItemLine(prod) | priceFilter }}</span>

                <!-- Offert article -->
                <span *ngIf="getSubTotalItemLine(prod) == 0">{{"basket.offer"|translate}}</span>

              </div>

            </div>

          </div>

          <!-- Action article -->
          <div class="flex flex-row gap-2 py-2">

            <!-- Contrôle Quantité -->
            <div class="flex items-center gap-2" *ngIf="!prod.free">
              <button (click)="removeProdQuant(index, prod)"
                      class="w-6 h-6 flex items-center justify-center bg-gray-100 rounded-full hover:bg-gray-200">-
              </button>
              <span class="text-sm">{{ prod.quantity }}</span>
              <button class="w-6 h-6 flex items-center justify-center bg-gray-100 rounded-full hover:bg-gray-200"
                      (click)="addProdQuant(index, prod)">+
              </button>
            </div>

            <span class="flex-1"></span>

            <!-- Modifier détail -->
            <div *ngIf="isMenuOptionCompatible(prod)">
              <button class="text-blue-500 hover:text-blue-700 text-sm ml-2"
                      (click)="openProdDial(prod, 'update', index)">
                <i class="fas fa-edit"></i>
              </button>
            </div>

            <!-- Supprimer -->
            <button class="text-red-500 hover:text-red-700 text-sm ml-2" (click)="removeProdPan(index, prod)">
              <i class="fas fa-trash-alt"></i>
            </button>

          </div>

          <!-- Commentaire article -->
          <div *ngIf="prod.comment && prod.comment != ''">
            <div class="text-xs text-gray-500 italic">{{ prod.comment }}</div>
          </div>

          <div *ngIf="prod.details && prod.details.length > 0"
               class="flex flex-row gap-2 py-2 items-center">

            <!-- Liste des options / détail formule -->
            <div class="flex-1">
              <div class="text-xs text-gray-500 italic">{{ getSubItemNames(prod) }}</div>
            </div>

          </div>

        </div>

      </div>

    </div>

  </div>

  <hr class="border-gray-300"/>

  <!-- Footer -->
  <div class="py-4">

    <!-- Total -->
    <div class="flex flex-row justify-between gap-2">

      <div class="text-lg font-semibold ">{{ "basket.total" | translate }}</div>

      <div class="text-lg font-bold">{{totalPricePan  | priceFilter}}</div>

    </div>

    <!-- Qté Articles -->
    <div class="flex flex-row justify-between gap-2">

      <!-- On spécifie Hors Frais livraison -->
      <div *ngIf="hasDeliveryOrShippingCost()">
        <span class="text-xs text-orange-700">{{ "basket.exclud-delivry" | translate }}</span>
      </div>

      <div class="text-xs" translate [translateParams]="{ count: totalQuantPan }">basket.qtyprod</div>
    </div>

    <!-- Minimum de commande -->
    <div class="flex justify-between text-xs text-orange-500" *ngIf="currSm.minimum_order">
      <span>{{ "basket.minimum" | translate }}</span>
      <span>{{currSm.minimum_order | priceFilter}}</span>
    </div>

  </div>

  <!-- Buttons -->
  <div class="mt-2">

    <div class="flex flex-row gap-4 items-center">

      <!-- Back Button -->
      <div fxHide fxShow.lt-lg>
        <button class="px-4 py-1 rounded-md bg-gray-100 text-gray-700 hover:bg-gray-200 transition"
                (click)="closeBasket()">
          <mat-icon>arrow_back_ios_new</mat-icon>
        </button>
      </div>

      <!-- End Order Button -->
      <div class="flex-1">
        <button class="w-full " [ngClass]="cssService.defaultPrimaryButton"
                [class.isDisabled]="panier$ && panier$.length === 0" (click)="goEndOrder()">
          <span *ngIf="(currSm && !currSm.enable_device_check) || !currSm">{{"basket.payment" | translate}}</span>
          <span *ngIf="currSm && currSm.enable_device_check">{{"button.validate" | translate}}</span>
        </button>
      </div>

    </div>

  </div>

</div>
